<template>
  <div>
    <h2>
      <span class="form-group">
        Young Stock
        <comments field-name='heading_young_stock' :isReadOnly="isReadOnly"></comments>
      </span>
    </h2>

		<div class="alert alert-success text-center">
			Most of this step is required except for optional parts marked in <strong>green</strong>.
		</div>

		<div class="alert alert-success">
			<programme-input programme-slug="welcalf"></programme-input>
		</div>

    <div class="row">
      <div class="col-md-6 col-md-offset-3">
        <div :class="{fonterraFields: isFonterraClient}" class="clearfix">

          <number-input label="Estimated calf mortality (#of replacement calves)"
                        field-name="cd_est_calf_mortality_count"
                        :disabled="isReadOnly">
          </number-input>

          <div class="form-group">
            <label>Calculated % of R1</label>
            <input type="text" class="form-control" :value="r1Percent" disabled>
          </div>

          <text-input label="Goal for the next season (%)"
                      field-name="cd_calf_mortality_goal_percent"
                      :disabled="isReadOnly">
          </text-input>

          <discussion-points title="Plan for calf mortality rate"
                             comments-field="mortality_rate_plan"
                             points="Multimin">
          </discussion-points>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div :class="{fonterraFields: isFonterraClient}" class="clearfix">

          <discussion-points title="Calf nutrition plan"
                             comments-field="cd_calf_nutrition_plan"
                             points="colostrum feeding/milk feeding/water availability/weaning process/monitoring weight gain etc.">
          </discussion-points>

          <discussion-points title="Calf housing plan"
                             comments-field="cd_calf_housing_plan"
                             points="substrate/ space allowance/ group size/ shelter availability when outside/ biosecurity procedure/ hospital pen etc.">
          </discussion-points>

          <discussion-points title="Calf health plan"
                             comments-field="cd_calf_health_plan"
                             points="FPT testing/disease incidence/ biosecurity/preventative health programmes like BVD testing/ vaccinations/mineral supplementations/ parasite management etc.">
          </discussion-points>

          <discussion-points title="Youngstock Plan - weaning to pregnancy"
                             comments-field="cd_weaning_plan"
                             points="For calves between weaning to pregnant R2s: trace elements, teat seal, nutrition, repro (6% empty or less).">
          </discussion-points>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h3>
          <span class="form-group">
            Calf Disbudding
            <comments field-name="young_stock_calf_disbudding" :isReadOnly="isReadOnly"></comments>
          </span>
        </h3>
        <label class="text-left"> Calf Disbudding Purchases </label>

        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Purchase Date</th>
              <th>Animal</th>
              <th>Product</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in getChartData('disbud_purchases_ev')" :key="index">
              <td class="text-left">{{ row["Purchase Date"] }}</td>
              <td class="text-left">{{ row["Animal"] }}</td>
              <td class="text-left">{{ row["Product"] }}</td>
              <td class="text-left">{{ row["Quantity"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div class="row">
      <div class="col-md-6 col-md-offset-3">
        <radio-input label="Wants to disbud with VetSouth?"
                     field-name="calf_bisbud_vs"
                     :choices="[
                                {value: 'Yes', display: 'Yes'},
                                {value: 'No', display: 'No'},
                                {value: 'Maybe', display: 'Maybe'},
                                ]"
                     :disabled="isReadOnly">
        </radio-input>

        <select-input label="Programme"
                      field-name="wants_disbud_program_type"
                      :disabled="isReadOnly"
                      :options="[
                                 {value: 'Gold', display: 'Gold'},
                                 {value: 'Silver', display: 'Silver'},
                                 {value: 'Standard', display: 'Standard'},
                                 {value: 'Diamond', display: 'Diamond'},
                                 ]">
        </select-input>

        <select-input label="Product"
                      field-name="wants_disbud_program_product"
                      :disabled="isReadOnly"
                      :options="[
                                 {value: '5 in 1', display: '5 in 1'},
                                 {value: '6 in 1', display: '6 in 1'},
                                 {value: 'Covexin 10', display: 'Covexin 10'},
                                 ]">
        </select-input>

        <radio-input label="BVD Testing?"
                     field-name="wants_ys_bvd_testing"
                     :choices="[
                                {value: 'Yes', display: 'Yes'},
                                {value: 'No', display: 'No'},
                                ]"
                     :disabled="isReadOnly">
        </radio-input>

        <select-input label="Type"
                      field-name="wants_ys_bvd_testing_type"
                      :disabled="isReadOnly"
                      :options="[
                                 {value: 'Ear notching', display: 'Ear notching'},
                                 {value: 'Bloods', display: 'Bloods'},
                                 ]">
        </select-input>

        <radio-input label="DNA Testing?"
                     field-name="wants_ys_dna_testing"
                     :choices="[
                                {value: 'Yes', display: 'Yes'},
                                {value: 'No', display: 'No'},
                                ]"
                     :disabled="isReadOnly">
        </radio-input>

        <p class="subtext">Remind client to order from LIC</p>

        <radio-input label="Needs calf disbudding training session? "
                     field-name="wants_disbud_training"
                     :choices="[
                               {value: 'Yes', display: 'Yes'},
                               {value: 'No', display: 'No'},
                               {value: 'Maybe', display: 'Maybe'},
                               ]"
                     :disabled="isReadOnly">
        </radio-input>

				<div class="alert alert-success">
					<div class="disease">
						<span class="form-group">
							<label>Any other young stock health issues?</label>
							<comments field-name="young_stock_issues" :isReadOnly="isReadOnly"></comments>
						</span>
					</div>
				</div>

      </div>

      <div class="row">
        <div class="col-md-6 col-md-offset-3">
					<programme-input programme-slug="complete-calf_care"></programme-input>
          <discussion-points title=""
                             points="Please add details, vet or FS to book?">
            <radio-input label="Dry stock trace element testing?"
                         field-name="dry_stock_ppp"
                         :add-comment="true"
                         comment-field-name="young_stock_dry_stock_ppp"
                         :choices="[
                                    {value: 'Yes', display: 'Yes'},
                                    {value: 'No', display: 'No'},
                                    {value: 'Maybe', display: 'Maybe'},
                                    ]"
                         :disabled="isReadOnly">
            </radio-input>
          </discussion-points>

          <discussion-points title=""
                             points="Please add contact name and number to comments">
            <radio-input label="Weigh it up"
                         field-name="heifer_weighing"
                         comment-field-name="young_stock_heifer_weighing_scheme"
                         :add-comment="true"
                         :addEmailNotification="true"
                         :choices="[
                                   {value: 'Yes', display: 'Yes'},
                                   {value: 'No', display: 'No'},
                                   {value: 'Maybe', display: 'Maybe'},
                                   ]"
                         :disabled="isReadOnly">
            </radio-input>

          </discussion-points>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'YoungStock',
  mixins: [ baseComponent ],
  computed: {
    ...mapGetters('currentConsult', [
      'isFonterraClient',
    ]),
    r1Percent: function ()
    {
      if (! this.getFieldValue('cd_est_calf_mortality_count')) { return ''}

      let r1s = this.getFieldValue('AGGREGATED_TOTALS', 'AnimalNumbers').r1
      return  ((this.getFieldValue('cd_est_calf_mortality_count') / r1s) * 100).toFixed(2) + '%'
    },
  },
  methods: {
    toggleNotifications: function() {
      this.setEmailNotification({
        slug: 'weigh-it-up',
        value: ['Yes', 'Maybe'].includes(this.getFieldValue('heifer_weighing', this.$options.name)),
      })
    }
  },
};
</script>

<style>
div .disease {
  margin-bottom: 1em;
}
</style>
